export default "__VITE_ASSET__DL9nwhAY__"